import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import SearchIcon from '@material-ui/icons/Search';

import style from '../awbInfo.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    input: {
      width: '150px'
    },
    button: {
      width: '100px',
      height: '40px'
    },
    disabled: {
      color: 'rgba(0, 0, 0, 0.26)'
    },
    textFieldsDisabled: {
      color: 'rgba(0, 0, 0, 0.26)'
    },
  });

interface AwbInfoSearchComponentProps {
  classes: any;
  awbNumber: string;
  label: string;
  handleChangeAwbNumber: (event: any) => void;
  search: () => void;
  type: string;
  buttonState: boolean;
};

const awbInfoSearchComponent = (props: AwbInfoSearchComponentProps) => {

  return (
    <div className={ commonStyles.searchWrapper } >
      <TextField
        value={ props.awbNumber }
        variant="outlined"
        onChange={ props.handleChangeAwbNumber }
        className={ props.classes.textField }
        InputProps={{
          className: [props.classes.textField,commonStyles.searchIpField].join(' '),
        }}
        InputLabelProps={{ className: [props.classes.textField, props.classes.textFieldLabel].join(' ') }}
        placeholder={ props.label }
      />

      <Button
        color="primary"
        variant="contained"
        onClick={ props.search }
        className={ commonStyles.searchBtn }
        disabled={ props.buttonState }
      >
        { props.type === 'inventory' ?  <SearchIcon className={commonStyles.iconSearch} /> :  <SearchIcon className={commonStyles.iconSearch} /> }
      </Button>

    </div>
  )
};

export default withStyles(styles)(awbInfoSearchComponent);